import { render, staticRenderFns } from "./RegistrationDocumentsPage.vue?vue&type=template&id=dd378b24&scoped=true"
import script from "./RegistrationDocumentsPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationDocumentsPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationDocumentsPage.vue?vue&type=style&index=0&id=dd378b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd378b24",
  null
  
)

export default component.exports